import React, { Component } from 'react';
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom'
import Loading from './components/utils/Loading';
import AdminHome from './components/admin/AdminHome'
import AdminLogin from './components/admin/AdminLogin'
import BigScreenVideo from './components/scoreboard/BigScreenVideo';
import BigScreenAnswers from './components/scoreboard/Scoreboard';
import SetUpTickets from './components/admin/SetUpTickets';
import SetUpRacer from './components/admin/SetUpRacer';
import SetUpGame from './components/admin/SetUpGame';
import SetUpTeamVariables from './components/admin/SetUpTeamVariables';
import SetUpRulesAndRegs from './components/admin/SetUpRulesAndRegs';
import SetUpTicketEmail from './components/admin/SetUpTicketEmail';
import LoginVariables from './components/admin/SetUpLoginVariables';
import { app } from './base'

function AuthenticatedAdminRoute({component: Component, authenticated, ...rest}) {
    return (
        <Route
            {...rest}
            render={(props) => {
              if(authenticated === true){
                return (
                  <Component {...props} {...rest} />
                )
              } else {
                return (
                  <Redirect to={{pathname: '/adminLogin', state: {from: props.location}}} />
                )
              }
              }} />
    )
}

class App extends Component {
    constructor(props) {
        super(props)
        this.setCurrentUser = this.setCurrentUser.bind(this)
        this.state = {
            authenticated: false,
            currentUser: null,
            loading: true
        }
    }

    setCurrentUser(user) {
      if (user) {
          this.setState({
              currentUser: user,
              authenticated: true
          })
      } else {
          this.setState({
              currentUser: null,
              authenticated: false
          })
      }
    }

    componentDidMount() {
        this.removeAuthListener = app.auth().onAuthStateChanged((user) => {
            if (user) {
                this.setState({
                    authenticated: true,
                    currentUser: user,
                    loading: false
                })
            } else {
                this.setState({
                    authenticated: false,
                    currentUser: null,
                    loading: false
                })
            }
        })
    }

    componentWillUnmount() {
        this.removeAuthListener()
    }

    render() {
        if (this.state.loading === true) {
            return (
                <Loading loading={this.state.loading}/>
            )
        }
        return (
          <div style={{ margin: "0 auto"}}>
            <BrowserRouter>
                <div className="main-content">
                    <div className="workspace">
                      <Switch>
                        <Route
                          exact
                          path="/bigscreenvideo"
                          render={(props) => {
                            return <BigScreenVideo {...props} />
                          }}
                        />
                        <Route
                              exact
                              path="/bigscreenanswers"
                              render={(props) => {
                                  return <BigScreenAnswers {...props} />
                              }}
                        />
                        <Route
                            exact
                            path="/adminlogin"
                            user={this.state.currentUser}
                            render={(props) => {
                              return <AdminLogin setCurrentUser={this.setCurrentUser} {...props} />
                            }} />

                        <AuthenticatedAdminRoute
                            exact
                            path="/admin"
                            authenticated={this.state.authenticated}
                            component={AdminHome} />

                        <AuthenticatedAdminRoute
                            exact
                            path="/setupgame"
                            authenticated={this.state.authenticated}
                            currentUser={this.state.currentUser}
                            component={SetUpGame} />

                        <AuthenticatedAdminRoute
                            exact
                            path="/setupracers"
                            authenticated={this.state.authenticated}
                            component={SetUpRacer} />

                        <AuthenticatedAdminRoute
                            exact
                            path="/setuptickets"
                            authenticated={this.state.authenticated}
                            component={SetUpTickets} />

                        <AuthenticatedAdminRoute
                            exact
                            path="/setupteamvariables"
                            authenticated={this.state.authenticated}
                            component={SetUpTeamVariables} />

                        <AuthenticatedAdminRoute
                            exact
                            path="/setuprulesandregs"
                            authenticated={this.state.authenticated}
                            component={SetUpRulesAndRegs} />

                        <AuthenticatedAdminRoute
                            exact
                            path="/setupticketemail"
                            authenticated={this.state.authenticated}
                            component={SetUpTicketEmail} />

                        <AuthenticatedAdminRoute
                              exact
                              path="/setuploginvariables"
                              authenticated={this.state.authenticated}
                              component={LoginVariables} />

                        <Redirect to="/adminlogin"/>
                      </Switch>
                    </div>
                </div>
            </BrowserRouter>
          </div>
        )
    }
}

export default App;
